<template>
	<div>
		<c-dialog ref="selector" title="选择人员" height="80vh" :button="false" enable-flex>
			<div class="selector-search-bar">
				<div class="selector-search flex-center">
					<i class="selector-search-icon c-icon-search"></i>
					<input v-model="keyword" class="flex-grow" @input="updateList">
				</div>
			</div>

			<c-scroll ref="scroll" class="flex-grow">
				<c-empty v-if="dataList && !dataList.length"></c-empty>
				<div v-for="(group, i) in dataList" :key="i" :ref="group.group_key">
					<p class="group">{{group.group_key}}</p>
					<div v-for="(item, j) in group.user_list" :key="j" class="item flex-center" @click="clickHandle(item)">
						<div class="check flex-center" :class="{'z-crt': currentList.find(crt => crt.id == item.id)}"><i class="c-icon-check"></i></div>
						<member-icon :icon="item.head_photo" :name="item.user_realname" circle></member-icon>
						<div class="flex-grow">
							<p class="ellipsis">{{item.user_realname}}</p>
							<p class="info">{{item.position_name || '-'}} | {{item.phone || '-'}}</p>
						</div>
					</div>
				</div>
			</c-scroll>

			<div class="nav flex-column">
				<div v-for="(group, i) in dataList" :key="i" class="flex-grow flex-center" @click="navHandle(group.group_key)">{{group.group_key}}</div>
			</div>

			<div class="current flex-between-center" :style="{'z-index': showCurrentList ? 1010 : 90}">
				<div class="flex-grow flex-center" @click="currentListHandle">
					<div class="icon flex-center-cross flex-grow">
						<template v-for="(item, i) in currentList">
							<member-icon v-if="i < 4" :key="i" :icon="item.head_photo" :name="item.name" size="0.72" circle></member-icon>
						</template>
					</div>
					<i v-if="currentList.length" class="angle tf-angle-up" :style="{'transform': showCurrentList ? 'rotate(180deg)' : ''}"></i>
				</div>
				<c-button color="main" size="dialog" @click="resolveHandle">确定</c-button>
			</div>
		</c-dialog>

		<c-dialog ref="currentList" :title="`已选中 (${currentList.length})`" :button="false" mask-close @close="currentListClose">
			<c-scroll class="current-list">
				<div v-for="(item, i) in currentList" :key="i" class="item flex-center" @click="currentList.splice(i, 1)">
					<div class="check flex-center z-crt"><i class="c-icon-check"></i></div>
					<member-icon :icon="item.head_photo" :name="item.name" circle></member-icon>
					<div class="flex-grow">
						<p class="ellipsis">{{item.name}}</p>
						<p class="info">{{item.data.position_name || '-'}} | {{item.data.phone || '-'}}</p>
					</div>
				</div>
			</c-scroll>
		</c-dialog>
	</div>
</template>

<script>
	import {debounce} from '@deanwu/vue-component-library-mobile'

	export default {
		name: 'staffSelector',

		props: {
			multiple: Boolean
		},

		data() {
			return {
				keyword: '',
				dataList: null,
				currentList: [],

				showCurrentList: false
			}
		},

		methods: {
			open(data = {}) {
				this.$refs.selector.open();
				this.keyword = '';
				this.dataList = null;
				this.currentList = [];
				this.updateList();
			},

			updateList: debounce(function() {
				this.request({
					url: '/sys_user/mini/select_list',
					data: {
						view_model: 1,
						keyword: this.keyword.trim()
					},
					success: data => {
						this.$refs.scroll.scrollTo(0, 0);
						this.dataList = data;
					}
				})
			}, 200),

			clickHandle(data) {
				if (this.multiple) {
					if (this.currentList.find(item => item.id == data.id)) {
						this.currentList.splice(this.currentList.findIndex(item => item.id == data.id), 1);
					} else {
						this.currentList.push({
							id: data.id,
							name: data.user_realname,
							data
						});
					}
				} else {
					this.currentList = [{
						id: data.id,
						name: data.user_realname,
						data
					}];
				}
			},

			navHandle(name) {
				this.$refs.scroll.$el.scrollTop += this.$refs[name][0].getBoundingClientRect().y - this.$refs.scroll.$el.getBoundingClientRect().y;
			},

			currentListHandle() {
				if (this.showCurrentList) {
					this.$refs.currentList.close();
				} else {
					this.showCurrentList = true;
					this.$refs.currentList.open();
				}
			},

			currentListClose() {
				setTimeout(() => {
					this.showCurrentList = false;
				}, 400);
			},

			resolveHandle() {
				if (!this.currentList.length) {
					this.$message({
						message: '未选择人员'
					});
					return;
				}

				this.$refs.selector.close();
				this.$emit('resolve', this.currentList);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.group {
		padding: .2rem .38rem 0;
		line-height: .4rem;
		font-size: .26rem;
		color: #999;
	}

	.item {
		gap: .24rem;
		height: 1.4rem;
		padding: 0 .6rem 0 .32rem;
		font-size: .32rem;

		.icon {
			width: .88rem;
			height: .88rem;
			border-radius: .44rem;
			font-size: .42rem;
			color: #fff;
			background: var(--color-main);
		}

		.info {
			margin-top: .16rem;
			font-size: .26rem;
			color: #7A859B;
		}

		.angle {
			font-size: .24rem;
			color: #B1BBCF;
		}

		.check {
			box-sizing: border-box;
			width: .4rem;
			height: .4rem;
			border: .04rem solid #ccc;
			border-radius: .08rem;
			font-size: .22rem;
			color: #fff;
			box-shadow: 3px 3px 8px 0 rgba(0,0,0,.1);

			&.z-crt {
				border-color: var(--color-main);
				background: var(--color-main);
			}
		}
	}

	.nav {
		position: fixed;
		right: 0;
		top: 2.6rem;
		bottom: 1.6rem;
		width: .6rem;

		div {
			max-height: .48rem;
			font-size: .26rem;
			color: #999;
			text-align: center;
		}
	}

	.current {
		gap: .35rem;
		min-height: 1.2rem;
		border-top: 1px solid #eee;
		padding: 0 .32rem var(--safe-area);
		background: #fff;

		&-list {
			height: 7rem;
			margin-bottom: var(--safe-area);
		}

		.icon {
			gap: .14rem;
		}

		.angle {
			font-size: .24rem;
			color: #B1BBCF;
		}
	}
</style>
